import React, { useContext, useEffect, useState } from 'react';

import RightScenes from '../../../../components/RightScenes/RightScenes';
import { GuarrantorDetailViewContext } from '../../Private';
import CardEntitiesAndLoans from './components/CardEntitiesAndLoans';
import CardProfile from './components/CardProfile';
import CardReport from './components/CardReport';
import { useGetOwnership } from '../../../../services/ownership/querys';

const BorrowerDetail = () => {

  const { visible: ownershipId, setHandlerVisible }: any = useContext(GuarrantorDetailViewContext);

  const { data: ownership, fetching: loading, reexecute: getOwnership } = useGetOwnership({
    variables: { ownershipId },
    pause: true
  });
  
  useEffect(() => {
    if (ownershipId)
      getOwnership({ requestPolicy: 'network-only' });
  }, [ownershipId])

  return (
    <RightScenes
      visible={!!ownershipId}
      handlerSetVisibile={() => setHandlerVisible(undefined)}
    >
      <div className='view-borrower-detail'>
        <div className='view-borrower-detail-header'>
          <h1 className='title'>
            <span>Borrower details</span>
          </h1>
        </div>

        <div className="flex-2-col">
          <div className="box">
            {/*<CardProfileNotifications />*/}
            {ownership && !loading &&
              <>
                <CardEntitiesAndLoans entities={ownership.entities || []} loans={ownership.loans || []} />
                <CardReport
                  reportKey="credit_score"
                  title="Credit report"
                  borrower={ownership}
                  isCreditScore
                  buttons={{ download: 'Download report', upload: 'Upload new report' }}
                />
                <CardReport
                  reportKey="background_check"
                  title="Background check"
                  borrower={ownership}
                  buttons={{ download: 'Download background check', upload: 'Upload new background check' }}
                />
              </>
            }
          </div>
          <div className="box">
            {ownership && <CardProfile {...ownership} />}
          </div>
        </div>
      </div>
    </RightScenes>
  );
};

export default BorrowerDetail;
